import { NavigationGuard } from "vue-router";
import userStore from "@/store/userStore";

const ensureCouncilSelected: NavigationGuard = (to, _from, next) => {
  try {
    if (to.name === "SelectCouncil" || to.name === "SignInCallback" || to.name === "Error") {
      next();
      return;
    }
    if (!userStore.activeCouncil) {
      if (userStore.user && userStore.availableCouncils.length === 1) {
        userStore.setActiveCouncil(userStore.user.profile["dcp-council"]);
        next();
      } else {
        next({ name: "SelectCouncil" });
      }
      return;
    }
    next();
  } catch (error) {
    console.log(error);
  }
};

export default ensureCouncilSelected;
